export default {
  channels: {
    frontLeft: 'Front Left',
    frontRight: 'Front Right',
    center: 'Center',
    lfe: 'LFE',
    sideLeft: 'Side Left',
    sideRight: 'Side Right',
    rearLeft: 'Rear Left',
    rearRight: 'Rear Right',
  },
  channelAbbreviations: {
    frontLeft: 'FL',
    frontRight: 'FR',
    center: 'C',
    lfe: 'LFE',
    sideLeft: 'SL',
    sideRight: 'SR',
    rearLeft: 'RL',
    rearRight: 'RR',
  },
  units: {
    decibel: 'dB',
  },
};
